import { applyMiddleware, compose, createStore, Store as ReduxStore } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';

import { StoreConnector } from '../common/store-connector';
import { app, ModeApp } from '../reducers/index';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Don't bother exporting the connector because it's angular specific and would be injected normally
export const reduxStore = createStore(
  app,
  composeEnhancers(applyMiddleware(<any>promiseMiddleware))
) as ReduxStore<ModeApp>;

export const storeServiceConnector = new StoreConnector<ModeApp>(reduxStore);

if (typeof window !== 'undefined') {
  window.onfocus = function () {
    reduxStore.dispatch({ type: 'WINDOW_FOCUS' });
  };

  window.onblur = function () {
    reduxStore.dispatch({ type: 'WINDOW_BLUR' });
  };
}
